export const BRAND = {
  name: "Mulywan",
  company: "CUTE GLOBAL TRADE",
  director: "Kundan Kumar",
  type: "Proprietorship",
  registered: "05 July 2024",
  gst: "10LHLPK7750C1ZD",
  udyam: "UDYAM-BR-30-0055394",
  fssai: "10426330000119",
  address: "Birnama Tula, Angarghat, Samastipur, Bihar 848134",
  addressShort: "Angarghat, Samastipur, Bihar",
};

export const CONTACT = {
  primary: "8002065231",
  secondary: "7488002960",
  primaryIntl: "918002065231",
  secondaryIntl: "917488002960",
};

export const MAP_EMBED =
  "https://www.google.com/maps?q=Angarghat%2C%20Samastipur%2C%20Bihar%20848134&output=embed";

export function whatsappUrl(number, message) {
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}

export function productEnquiryUrl({ name, mobile, product }) {
  const msg =
    `Hello Mulywan 👋\n\n` +
    `I'm interested in the following product:\n` +
    `• Product: ${product}\n\n` +
    `My details —\n` +
    `Name: ${name}\n` +
    `Mobile: ${mobile}\n\n` +
    `Please share pricing & availability.`;
  return whatsappUrl(CONTACT.primaryIntl, msg);
}

export function contactEnquiryUrl({ name, mobile, email, message }) {
  const msg =
    `Hello Mulywan 👋 — New enquiry from website\n\n` +
    `Name: ${name}\n` +
    `Mobile: ${mobile}\n` +
    (email ? `Email: ${email}\n` : ``) +
    `\nMessage:\n${message || "—"}`;
  return whatsappUrl(CONTACT.primaryIntl, msg);
}
